"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _toConsumableArray2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _apolloClient = require("@/apollo/apolloClient");
var _companyQuery = require("@/apollo/queries/company-query");
var state = {
  // ページング（ページトップNo）
  page_top: 0,
  // ページング（１ページあたりの表示サイズ）
  page_size: 10,
  // ページング（全一覧数）
  page_count: 0,
  // ページング（最終ページ）
  page_last: 0,
  // 文字検索
  searching: '',
  // 企業名検索
  searchCompanyName: '',
  // 代表者名
  searchCtoName: '',
  // 業種名／職種名検索
  searchIndustryName: '',
  // 電話番号検索
  searchTel: '',
  industrys: [],
  branchs: [],
  display: [],
  login: [],
  occupations: [],
  certificationMarks: [],
  area: [],
  companies: [],
  company_id: null,
  uid: '',
  area_id: '',
  branchCode: null,
  areaCode: null,
  majorCode: null,
  middleCode: null,
  industry_major: null,
  industry_middle: null,
  industry_code: '',
  industry_info: [],
  group_id: '',
  company: [],
  members: [],
  member: [],
  affiliationList: [],
  pathToListItem: [],
  enableTextAllSelect: false,
  listAllIdsFromLastItem: []
};
var mutations = {
  UPDATE_COMPANY: function UPDATE_COMPANY(state, user) {
    state.member = user.map(function (com) {
      return com;
    });
  },
  UPDATE_COMPANY_LIST: function UPDATE_COMPANY_LIST(state, company) {
    state.companies = company.map(function (com) {
      com.thumbsUp = com.like.aggregate.count;
      com.viewed = com.browse.aggregate.count;
      if (com.profile === null) {
        com.industry = '';
        com.cto = '';
        com.address = '';
        com.tel = '';
        com.email = '';
      } else {
        if (com.industry_companies.length === 0) {
          com.industry = '';
        } else {
          com.industry = com.industry_companies[0].industry.name;
        }
        com.cto = com.profile.cto;
        com.address = com.profile.address;
        com.tel = com.profile.tel;
        com.email = com.profile.email;
      }
      return com;
    });
  },
  UPDATE_MEMBERS: function UPDATE_MEMBERS(state, user) {
    var _listStringAffiliation = [];
    state.members = user.map(function (com) {
      com.name = com.full_name;
      com.name_kana = com.full_name_furigana;
      if (com.company !== null) {
        com.company_name = com.company.company_name;
        if (com.company.industries != null) {
          com.industry_name = com.company.industries.industry_name;
        } else {
          com.industry_name = '';
        }
      } else {
        com.company_name = '';
        com.industry_name = '';
      }
      _listStringAffiliation = [];
      var _listAffiliationIsMain = [];
      if (com.user_affiliations && com.user_affiliations.length !== 0) {
        com.user_affiliations.forEach(function (item) {
          if (item.affiliation) {
            if (item.affiliation.is_main) {
              if (item.affiliation.parent_id === null) item.affiliation.parent_id = 0;
              _listAffiliationIsMain.push(item);
            }
          }
        });
        if (_listAffiliationIsMain && _listAffiliationIsMain.length !== 0) {
          _listAffiliationIsMain.sort(function (a, b) {
            return a.affiliation.parent_id - b.affiliation.parent_id;
          });
          _listAffiliationIsMain.map(function (e) {
            if (e.affiliation.name) {
              return _listStringAffiliation.push(e.affiliation.name);
            }
          });
        }
      }
      if (_listStringAffiliation && _listStringAffiliation.length !== 0) {
        com.userAffiliation = (0, _toConsumableArray2.default)(new Set(_listStringAffiliation)).join(' / ');
      } else {
        com.userAffiliation = '';
      }
      return com;
    });
  },
  CREATE_INDUSTRY_MAJOR_LIST: function CREATE_INDUSTRY_MAJOR_LIST(state, industry_major) {
    state.industry_major = industry_major.map(function (com) {
      com.no = com.id;
      com.title = com.name;
      return com;
    });
  },
  CREATE_INDUSTRY_MIDDLE_LIST: function CREATE_INDUSTRY_MIDDLE_LIST(state, industry_middle) {
    state.industry_middle = industry_middle.map(function (com) {
      com.no = com.code;
      com.title = com.name;
      return com;
    });
  },
  CREATE_INDUSTRY_MIDDLE_INFO: function CREATE_INDUSTRY_MIDDLE_INFO(state, industry_middle) {
    state.industry_info = industry_middle;
  },
  CREATE_DISPLAY_LIST: function CREATE_DISPLAY_LIST(state, display) {
    state.display = display.map(function (com) {
      com.no = com.id;
      com.title = com.name;
      return com;
    });
  },
  CREATE_LOGIN_LIST: function CREATE_LOGIN_LIST(state, login) {
    state.login = login.map(function (com) {
      com.no = com.id;
      com.title = com.name;
      return com;
    });
  },
  GET_ALL_AFFILIATION: function GET_ALL_AFFILIATION(state, _affilication) {
    // /tree listのすべての配列に 全てのグループ を追加します
    var counter = -1;
    function getMapAffilication(_subAffiliation) {
      if (_subAffiliation.affiliations.length >= 1) {
        counter = counter - 1;
        if (_subAffiliation.affiliations[0].name !== '全てのグループ' && state.enableTextAllSelect) {
          _subAffiliation.affiliations.unshift({
            affiliations: [],
            id: counter,
            name: '全てのグループ',
            parent_id: _subAffiliation.affiliations[0].parent_id
          });
        }
      }
      return _subAffiliation.affiliations.map(function (subItem) {
        return getMapAffilication(subItem);
      });
    }
    if (_affilication[0].name !== '全てのグループ' && state.enableTextAllSelect) {
      _affilication.unshift({
        affiliations: [],
        id: counter,
        name: '全てのグループ',
        parent_id: _affilication[0].parent_id
      });
    }
    _affilication.map(function (itemAffilication) {
      return getMapAffilication(itemAffilication);
    });
    state.affiliationList = _affilication;
  },
  setPageTop: function setPageTop(state, val) {
    state.page_top = val;
  },
  setPageSize: function setPageSize(state, val) {
    state.page_size = val;
  },
  setPageCount: function setPageCount(state, val) {
    state.page_count = val;
  },
  setSearching: function setSearching(state, val) {
    state.searching = val;
  },
  setCtoName: function setCtoName(state, val) {
    state.searchCtoName = val;
  },
  setCompanyName: function setCompanyName(state, val) {
    state.searchCompanyName = val;
  },
  setIndustryName: function setIndustryName(state, val) {
    state.searchIndustryName = val;
  },
  setTel: function setTel(state, val) {
    state.searchTel = val;
  },
  setMajorCode: function setMajorCode(state, val) {
    state.majorCode = val;
  },
  setMiddleCode: function setMiddleCode(state, val) {
    state.middleCode = val;
  },
  clear: function clear(state) {
    state.searching = '';
    state.branchCode = null;
    state.areaCode = null;
    state.majorCode = null;
    state.middleCode = null;
    state.searchCtoName = '';
    state.searchCompanyName = '';
    state.searchIndustryName = '';
    state.searchTel = '';
    state.industrys = [];
    state.industry_major = []; // 大分類
    state.industry_middle = []; // 中分類
    state.branchs = [];
    state.area = [];
    state.industry_info = [];
    state.industry_code = '';
    state.display = [];
    state.login = [];
    state.occupations = [];
    state.certificationMarks = [];
    state.companies = [];
    state.company = [];
    state.company_id = null;
  },
  pathToListItem: function pathToListItem(state, val) {
    state.pathToListItem = val;
  },
  setEnableTextAllSelect: function setEnableTextAllSelect(state, val) {
    state.enableTextAllSelect = val;
  },
  getDataSearchAffiliation: function getDataSearchAffiliation(state, val) {
    state.listAllIdsFromLastItem = val;
  }
};
var actions = {
  getIndustryMajorList: function () {
    var _getIndustryMajorList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
      var commit, res;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            commit = _ref.commit;
            _context.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.INDUSTRY_MAJOR_LIST
            });
          case 1:
            res = _context.v;
            commit('CREATE_INDUSTRY_MAJOR_LIST', res.data.industry_group);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    function getIndustryMajorList(_x) {
      return _getIndustryMajorList.apply(this, arguments);
    }
    return getIndustryMajorList;
  }(),
  getIndustryMiddleList: function () {
    var _getIndustryMiddleList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(_ref2, data) {
      var commit, res;
      return (0, _regenerator2.default)().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            commit = _ref2.commit;
            this.state.group_id = data.group_id;
            _context2.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.INDUSTRY_MIDDLE_LIST,
              variables: {
                group_id: this.state.group_id
              }
            });
          case 1:
            res = _context2.v;
            commit('CREATE_INDUSTRY_MIDDLE_LIST', res.data.industries);
          case 2:
            return _context2.a(2);
        }
      }, _callee2, this);
    }));
    function getIndustryMiddleList(_x2, _x3) {
      return _getIndustryMiddleList.apply(this, arguments);
    }
    return getIndustryMiddleList;
  }(),
  getIndustryMiddleInfo: function () {
    var _getIndustryMiddleInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(_ref3, data) {
      var commit, res;
      return (0, _regenerator2.default)().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            commit = _ref3.commit;
            this.state.industry_code = data.industry_code;
            _context3.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.INDUSTRY_MIDDLE_INFO,
              variables: {
                code: this.state.industry_code
              }
            });
          case 1:
            res = _context3.v;
            commit('CREATE_INDUSTRY_MIDDLE_INFO', res.data.industries);
          case 2:
            return _context3.a(2);
        }
      }, _callee3, this);
    }));
    function getIndustryMiddleInfo(_x4, _x5) {
      return _getIndustryMiddleInfo.apply(this, arguments);
    }
    return getIndustryMiddleInfo;
  }(),
  getSearchIndustryMajorList: function () {
    var _getSearchIndustryMajorList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(_ref4) {
      var commit, res, add;
      return (0, _regenerator2.default)().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            commit = _ref4.commit;
            _context4.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.INDUSTRY_MAJOR_LIST
            });
          case 1:
            res = _context4.v;
            add = {
              id: 0,
              name: '全ての大分類'
            };
            if (res.data.industry_group[0].id !== 0) {
              res.data.industry_group.unshift(add);
            }
            commit('CREATE_INDUSTRY_MAJOR_LIST', res.data.industry_group);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    function getSearchIndustryMajorList(_x6) {
      return _getSearchIndustryMajorList.apply(this, arguments);
    }
    return getSearchIndustryMajorList;
  }(),
  getSearchIndustryMiddleList: function () {
    var _getSearchIndustryMiddleList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(_ref5, data) {
      var commit, res, industry_middle_list, add, add2;
      return (0, _regenerator2.default)().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            commit = _ref5.commit;
            this.state.group_id = data.group_id;
            _context5.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.INDUSTRY_MIDDLE_LIST,
              variables: {
                group_id: this.state.group_id
              }
            });
          case 1:
            res = _context5.v;
            industry_middle_list = [];
            if (res.data.industries[0] !== undefined) {
              add = {
                code: '00',
                name: '全ての中分類'
              };
              industry_middle_list = res.data.industries;
              industry_middle_list.unshift(add);
            } else {
              add2 = {
                code: '00',
                name: '全ての中分類'
              };
              industry_middle_list.unshift(add2);
            }
            commit('CREATE_INDUSTRY_MIDDLE_LIST', industry_middle_list);
          case 2:
            return _context5.a(2);
        }
      }, _callee5, this);
    }));
    function getSearchIndustryMiddleList(_x7, _x8) {
      return _getSearchIndustryMiddleList.apply(this, arguments);
    }
    return getSearchIndustryMiddleList;
  }(),
  getDisplayList: function () {
    var _getDisplayList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(_ref6) {
      var commit, displayList;
      return (0, _regenerator2.default)().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            commit = _ref6.commit;
            displayList = [{
              id: false,
              name: '非表示'
            }, {
              id: true,
              name: '表示'
            }];
            commit('CREATE_DISPLAY_LIST', displayList);
          case 1:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    function getDisplayList(_x9) {
      return _getDisplayList.apply(this, arguments);
    }
    return getDisplayList;
  }(),
  getLoginList: function () {
    var _getLoginList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7(_ref7) {
      var commit, loginList;
      return (0, _regenerator2.default)().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            commit = _ref7.commit;
            loginList = [{
              id: false,
              name: 'ログイン不可'
            }, {
              id: true,
              name: 'ログイン可'
            }];
            commit('CREATE_LOGIN_LIST', loginList);
          case 1:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    function getLoginList(_x0) {
      return _getLoginList.apply(this, arguments);
    }
    return getLoginList;
  }(),
  fetchCompany: function () {
    var _fetchCompany = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8(_ref8, data) {
      var commit, res;
      return (0, _regenerator2.default)().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            commit = _ref8.commit;
            this.state.uid = data.uid;
            _context8.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.GET_MEMBER,
              variables: {
                uid: this.state.uid
              }
            });
          case 1:
            res = _context8.v;
            commit('UPDATE_COMPANY', res.data.user);
          case 2:
            return _context8.a(2);
        }
      }, _callee8, this);
    }));
    function fetchCompany(_x1, _x10) {
      return _fetchCompany.apply(this, arguments);
    }
    return fetchCompany;
  }(),
  fetchMembers: function () {
    var _fetchMembers = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9(_ref9) {
      var commit, _sText, affiliations, result, res;
      return (0, _regenerator2.default)().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            commit = _ref9.commit;
            if (state.searching) {
              _sText = '%' + state.searching + '%';
            } else {
              _sText = '%';
            }
            affiliations = state.listAllIdsFromLastItem.length === 0 ? null : state.listAllIdsFromLastItem.join();
            result = [];
            _context9.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.SEARCH_MEMBERS_WITH_AFFILIATION,
              variables: {
                search_word: _sText,
                affiliations: affiliations,
                industry_code: state.middleCode,
                group_industry_id: state.majorCode,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 1:
            res = _context9.v;
            result = res.data.search_members_with_affiliation;
            state.page_count = res.data.search_members_with_affiliation_aggregate.aggregate.count;
            state.page_last = res.data.search_members_with_affiliation_aggregate.aggregate.count === 0 ? 0 : Math.ceil(res.data.search_members_with_affiliation_aggregate.aggregate.count / state.page_size) - 1;
            commit('UPDATE_MEMBERS', result);
          case 2:
            return _context9.a(2);
        }
      }, _callee9);
    }));
    function fetchMembers(_x11) {
      return _fetchMembers.apply(this, arguments);
    }
    return fetchMembers;
  }(),
  fetchMembersForExport: function () {
    var _fetchMembersForExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee0() {
      var _sText, affiliations, res;
      return (0, _regenerator2.default)().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            if (state.searching) {
              _sText = '%' + state.searching + '%';
            } else {
              _sText = '%';
            }
            affiliations = state.listAllIdsFromLastItem.length === 0 ? null : state.listAllIdsFromLastItem.join();
            _context0.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.EXPORT_MEMBERS_WITH_AFFILIATION,
              variables: {
                search_word: _sText,
                affiliations: affiliations,
                industry_code: state.middleCode,
                group_industry_id: state.majorCode
              }
            });
          case 1:
            res = _context0.v;
            return _context0.a(2, res.data.search_members_with_affiliation);
        }
      }, _callee0);
    }));
    function fetchMembersForExport() {
      return _fetchMembersForExport.apply(this, arguments);
    }
    return fetchMembersForExport;
  }(),
  fetchAffiliation: function () {
    var _fetchAffiliation = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee1(_ref0) {
      var commit, res, dataAffiliation, fakeIdAffiliation, indexFake;
      return (0, _regenerator2.default)().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            fakeIdAffiliation = function _fakeIdAffiliation(affiliation) {
              affiliation.idFake = indexFake;
              indexFake++;
              if (affiliation.affiliations) return affiliation.affiliations.map(function (item) {
                return fakeIdAffiliation(item);
              });
            };
            commit = _ref0.commit;
            _context1.n = 1;
            return _apolloClient.apolloClient.query({
              query: _companyQuery.AFFILIATION_LIST
            });
          case 1:
            res = _context1.v;
            dataAffiliation = res.data.affiliation;
            if (dataAffiliation.length !== 0 && dataAffiliation) {
              indexFake = 0;
              dataAffiliation.map(function (item) {
                return fakeIdAffiliation(item);
              });
            }
            commit('GET_ALL_AFFILIATION', dataAffiliation);
          case 2:
            return _context1.a(2);
        }
      }, _callee1);
    }));
    function fetchAffiliation(_x12) {
      return _fetchAffiliation.apply(this, arguments);
    }
    return fetchAffiliation;
  }(),
  setSearching: function () {
    var _setSearching = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee10(_ref1, searching) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            commit = _ref1.commit;
            commit('setSearching', searching);
          case 1:
            return _context10.a(2);
        }
      }, _callee10);
    }));
    function setSearching(_x13, _x14) {
      return _setSearching.apply(this, arguments);
    }
    return setSearching;
  }(),
  setMajorCode: function () {
    var _setMajorCode = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee11(_ref10, majorCode) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            commit = _ref10.commit;
            commit('setMajorCode', majorCode);
          case 1:
            return _context11.a(2);
        }
      }, _callee11);
    }));
    function setMajorCode(_x15, _x16) {
      return _setMajorCode.apply(this, arguments);
    }
    return setMajorCode;
  }(),
  setMiddleCode: function () {
    var _setMiddleCode = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee12(_ref11, middleCode) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context12) {
        while (1) switch (_context12.n) {
          case 0:
            commit = _ref11.commit;
            commit('setMiddleCode', middleCode);
          case 1:
            return _context12.a(2);
        }
      }, _callee12);
    }));
    function setMiddleCode(_x17, _x18) {
      return _setMiddleCode.apply(this, arguments);
    }
    return setMiddleCode;
  }(),
  setPageTop: function () {
    var _setPageTop = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee13(_ref12, page_top) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context13) {
        while (1) switch (_context13.n) {
          case 0:
            commit = _ref12.commit;
            commit('setPageTop', page_top);
          case 1:
            return _context13.a(2);
        }
      }, _callee13);
    }));
    function setPageTop(_x19, _x20) {
      return _setPageTop.apply(this, arguments);
    }
    return setPageTop;
  }(),
  getPageTop: function () {
    var _getPageTop = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee14(_ref13) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context14) {
        while (1) switch (_context14.n) {
          case 0:
            commit = _ref13.commit;
            return _context14.a(2, state.page_top);
        }
      }, _callee14);
    }));
    function getPageTop(_x21) {
      return _getPageTop.apply(this, arguments);
    }
    return getPageTop;
  }(),
  getPageLast: function () {
    var _getPageLast = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee15(_ref14) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context15) {
        while (1) switch (_context15.n) {
          case 0:
            commit = _ref14.commit;
            return _context15.a(2, state.page_last);
        }
      }, _callee15);
    }));
    function getPageLast(_x22) {
      return _getPageLast.apply(this, arguments);
    }
    return getPageLast;
  }(),
  setPageSize: function () {
    var _setPageSize = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee16(_ref15, page_size) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context16) {
        while (1) switch (_context16.n) {
          case 0:
            commit = _ref15.commit;
            commit('setPageSize', page_size);
          case 1:
            return _context16.a(2);
        }
      }, _callee16);
    }));
    function setPageSize(_x23, _x24) {
      return _setPageSize.apply(this, arguments);
    }
    return setPageSize;
  }(),
  setPageCount: function () {
    var _setPageCount = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee17(_ref16, page_count) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context17) {
        while (1) switch (_context17.n) {
          case 0:
            commit = _ref16.commit;
            commit('setPageCount', page_count);
          case 1:
            return _context17.a(2);
        }
      }, _callee17);
    }));
    function setPageCount(_x25, _x26) {
      return _setPageCount.apply(this, arguments);
    }
    return setPageCount;
  }(),
  getPageCount: function () {
    var _getPageCount = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee18(_ref17) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context18) {
        while (1) switch (_context18.n) {
          case 0:
            commit = _ref17.commit;
            return _context18.a(2, state.page_count);
        }
      }, _callee18);
    }));
    function getPageCount(_x27) {
      return _getPageCount.apply(this, arguments);
    }
    return getPageCount;
  }(),
  setCtoName: function () {
    var _setCtoName = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee19(_ref18, searchCtoName) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context19) {
        while (1) switch (_context19.n) {
          case 0:
            commit = _ref18.commit;
            commit('setCtoName', searchCtoName);
          case 1:
            return _context19.a(2);
        }
      }, _callee19);
    }));
    function setCtoName(_x28, _x29) {
      return _setCtoName.apply(this, arguments);
    }
    return setCtoName;
  }(),
  setCompanyName: function () {
    var _setCompanyName = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee20(_ref19, searchCompanyName) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context20) {
        while (1) switch (_context20.n) {
          case 0:
            commit = _ref19.commit;
            commit('setCompanyName', searchCompanyName);
          case 1:
            return _context20.a(2);
        }
      }, _callee20);
    }));
    function setCompanyName(_x30, _x31) {
      return _setCompanyName.apply(this, arguments);
    }
    return setCompanyName;
  }(),
  setIndustryName: function () {
    var _setIndustryName = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee21(_ref20, searchIndustryName) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context21) {
        while (1) switch (_context21.n) {
          case 0:
            commit = _ref20.commit;
            commit('setIndustryName', searchIndustryName);
          case 1:
            return _context21.a(2);
        }
      }, _callee21);
    }));
    function setIndustryName(_x32, _x33) {
      return _setIndustryName.apply(this, arguments);
    }
    return setIndustryName;
  }(),
  setTel: function () {
    var _setTel = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee22(_ref21, searchTel) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context22) {
        while (1) switch (_context22.n) {
          case 0:
            commit = _ref21.commit;
            commit('setTel', searchTel);
          case 1:
            return _context22.a(2);
        }
      }, _callee22);
    }));
    function setTel(_x34, _x35) {
      return _setTel.apply(this, arguments);
    }
    return setTel;
  }(),
  clear: function () {
    var _clear = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee23(_ref22) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context23) {
        while (1) switch (_context23.n) {
          case 0:
            commit = _ref22.commit;
            commit('clear');
          case 1:
            return _context23.a(2);
        }
      }, _callee23);
    }));
    function clear(_x36) {
      return _clear.apply(this, arguments);
    }
    return clear;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};